'use client';

import { Tab } from '@common/components';

import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';

export const Tabs = ({ className }: { className?: string }) => {
  return (
    <Tab value={DONATION_ROUTES.MY_ETC_NOTICE.pathname} className={className}>
      <Tab.Item value={DONATION_ROUTES.MY_ETC_EVENT.pathname}>
        <CustomLink
          href={DONATION_ROUTES.MY_ETC_EVENT.pathname}
          aria-label="이벤트 페이지로 이동"
          className="size-full flex-center"
          replace
        >
          이벤트
        </CustomLink>
      </Tab.Item>
      <Tab.Item value={DONATION_ROUTES.MY_ETC_NOTICE.pathname}>
        <CustomLink
          href={DONATION_ROUTES.MY_ETC_NOTICE.pathname}
          aria-label="공지사항 페이지로 이동"
          className="size-full flex-center"
          replace
        >
          공지사항
        </CustomLink>
      </Tab.Item>
    </Tab>
  );
};
